<template>
	<ActivityPanelLayout class="goal-activity-panel">
		<template #title>{{ $t( "common-gokr.components.GoalActivityPanel.title" ) }}</template>
		<template #feed>
			<!-- TODO: implement full feed here? -->
			<slot></slot>
		</template>
	</ActivityPanelLayout>
</template>

<script>
import ActivityPanelLayout from "../Activity/ActivityPanelLayout";
export default {
	name: "GoalActivityPanel",
	components: {
		ActivityPanelLayout,
	},
};
</script>

<style lang="scss" scoped></style>
